import * as yup from 'yup'

export const gatewaysFormValidationSchema = yup.object({
  basicDetails: yup.object().shape({
    name: yup.string().required('This field is required'),
    entityId: yup.string().required('This field is required'),
    supportedCurrencies: yup
      .array()
      .of(yup.string())
      .min(0, 'Select at least one currency')
      .required('This field is required'),
    description: yup.string().required('This field is required'),
    walletType: yup.string().required('This field is required')
  }),
  credential: yup.object().shape({
    credentialMode: yup.string().required('This field is required'),
    gatewaysType: yup.string().required('This field is required')
  })
  // credentialModeDetails: yup.object().shape({
  //   username:yup.string().when(
  //     []
  //   )
  // })
  //I need to ask
})
